<template>
  <span v-if="collapsed">
    {{ text.substring(0,50) }}&nbsp;<a
      v-if="text.length > 50"
      @click="expand"
    >More</a>
  </span>
  <span v-else>
    {{ text }}&nbsp;<a
      v-if="text.length > 50"
      @click="contract"
    >Less</a>
  </span>
</template>
<script>
export default {
  props: ['text'],
  data() {
    return {
      collapsed: true,
    };
  },
  methods: {
    expand() {
      this.collapsed = false;
    },
    contract() {
      this.collapsed = true;
    },
  },
};
</script>
